import { Button, Modal, Stack } from 'react-bootstrap';

interface ModalMessageParams {
  message: string;
  setShowModal: (show: boolean) => void;
}

function ModalMessage({ message, setShowModal }: ModalMessageParams) {
  const handleClose = () => setShowModal(false);

  return (
    <Modal show onHide={handleClose} centered>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Stack direction="horizontal" gap={4}>
          <Button variant="light" size="sm" onClick={handleClose}>
            Close
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalMessage;
